import { render, staticRenderFns } from "./all-comments.vue?vue&type=template&id=079749e4&"
import script from "./all-comments.vue?vue&type=script&lang=ts&"
export * from "./all-comments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports